import React from 'react';
import styled from 'styled-components';
import { MdOutlineColorLens } from "react-icons/md";

const Icon = styled(MdOutlineColorLens)`
    color: #fff;
    font-size:35px;
    transition: background-color 0.3s ease;
    cursor:pointer;
    &:hover {
        color: #4bf2cc;
    }
`
const ColorPaletteIcon = () => {
    return(
        <React.Fragment>
                <Icon/>
        </React.Fragment>
    )
}
export default ColorPaletteIcon;
